import { render, staticRenderFns } from "./RsaConfigurazioneAttivitaViewComponent.vue?vue&type=template&id=21fadb84"
import script from "./RsaConfigurazioneAttivitaViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAttivitaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports